
import { defineComponent } from "vue";
import CreateEditDialog from "@/components/controls/catalogueGrid/CreateEditDialog.vue";
import mountComponentMixin from "@/mixins/MountComponentMixin";
import EnumControl from "@/components/controls/base/EnumControl.vue";
import TractorCreateEditDialog from "./Tractor/TractorCreateEditDialog.vue"
import ContainerCreateEditDialog from "./Container/ContainerCreateEditDialog.vue"
import DxTextBox from "devextreme-vue/text-box";
import { TransportType } from "./TransportType"

export default defineComponent({
  components: {
    CreateEditDialog,
    EnumControl,
    TractorCreateEditDialog,
    ContainerCreateEditDialog,
    DxTextBox,
  },
  mixins: [mountComponentMixin],
  props: {
    saveModelCallback: { required: true },
  },
  computed: {
    isContainer() {
      return this.transportType == TransportType.Container;
    },
    isTractor() {
      return this.transportType == TransportType.Tractor;
    }
  },
  methods: {
    dialog() {
      return this.$refs.dialog as any;
    },
    open(model: any, editType: any) {
      this.dialog().open(model, editType);
      this.model = model;
      this.firstDisplay = true;
      this.tractorSettingsVisibility = false;
    },
    close() {
      this.dialog().close();
    },
    save() {
      this.dialog().save();
    },
    onTypeChange(){
      this.transportType = this.model.transportType;
      if (this.firstDisplay)
        this.firstDisplay = false;
      else
        this.resetModel();
    },
    resetModel(){
      for (var key in this.model) {
        switch(key) {
          case "id":
          case "name":
          case "transportType":
          case "transportTypeDescription":
          case "displacementId":
          case "displacementDescription":
            break;
          case "gapId":
          case "tractorType":
          case "semitrailerType":
            this.model[key] = null;
            break;
          default:
            if (typeof this.model[key] == "string")
              this.model[key] = null;
            if (typeof this.model[key] == "number")
              this.model[key] = 0;
        }
      }
    },
    saveData(e: any){
      if (this.isTractor)
        this.$refs.tractorCreateEditDialog.saveData(e);
    },
    changeSettingsVisibility(visibility: any) {
      this.tractorSettingsVisibility = visibility;
    },
  },
  data(){
    return {
      tractorSettingsVisibility: false,
      firstDisplay: true,
      model: null,
      transportType: null,
    };
  },
});
